import { IKeyVal } from "../shared/Password";
import Utils from "../libs/Utils";
import { useState } from "react";
import { useSnackbar } from "../gui/Snackbar/SnackbarProvider";
import IconButton from "../gui/Button/IconButton";
import CopyIcon from "../gui/Icons/CopyIcon";

export default function PropertyList(props:{data:IKeyVal}) {
    const [show,setShow] = useState<boolean>(false)
    const {data} = props
    const {addSnackbar} = useSnackbar()
    const onCopy = () => {
        Utils.clipboard(data.val)
        addSnackbar("Copied");
    }
    return <>
        <label>{data.key}</label>
        <div onClick={() => setShow(!show)}>{show ? data.val : "*********"}</div>
        <IconButton onClick={onCopy}><CopyIcon/></IconButton>
    </>
}